module.exports = __webpack_public_path__ + "static/explogo-4512508429018d0ec55111e28cd46d33.jpg";